import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';
import { AiChatTableComponent } from './ai-chat-table/ai-chat-table.component';
import { AiChatBarChartComponent } from './ai-chat-bar-chart/ai-chat-bar-chart.component';
import { AiChatLineChartComponent } from './ai-chat-line-chart/ai-chat-line-chart.component';
import { AiChatPieChartComponent } from './ai-chat-pie-chart/ai-chat-pie-chart.component';
import { AiChatGaugeChartComponent } from './ai-chat-gauge-chart/ai-chat-gauge-chart.component';
import { AiChatBannerComponent } from './ai-chat-banner/ai-chat-banner.component';
import { AiChatScoreComponent } from './ai-chat-score/ai-chat-score.component';
import { AiChatSectionComponent } from './ai-chat-section/ai-chat-section.component';
import { AiChatGenerativeButtonComponent } from './ai-chat-button/ai-chat-button.component';

const SERIALIZERS: Record<string, (data: Record<string, unknown>) => string> = {
  table: AiChatTableComponent.serialize,
  bar_chart: AiChatBarChartComponent.serialize,
  line_chart: AiChatLineChartComponent.serialize,
  pie_chart: AiChatPieChartComponent.serialize,
  gauge_chart: AiChatGaugeChartComponent.serialize,
  banner: AiChatBannerComponent.serialize,
  score: AiChatScoreComponent.serialize,
  section: AiChatSectionComponent.serialize,
  button: AiChatGenerativeButtonComponent.serialize,
};

export function serializeComponentChunk(chunk: IChatV2ComponentChunk): string {
  const serializer = SERIALIZERS[chunk.componentType];
  return serializer ? serializer(chunk.data ?? {}) : '';
}
